import { useLocation, Link } from "react-router-dom";
import { Search, PanelLeftClose, PanelLeftOpen, ChevronRight } from "lucide-react";
import { NotificationCenter } from "./NotificationCenter";
import { ProfileMenu } from "./ProfileMenu";
import { V2_NAV_FLAT } from "@/v2/nav";

export function V2TopBar({ collapsed, onToggleSidebar, onOpenPalette, theme, onToggleTheme }) {
  const { pathname } = useLocation();
  const current = V2_NAV_FLAT.find((n) => pathname === n.to || pathname.startsWith(n.to + "/"));

  return (
    <header className="v2-topbar" data-testid="v2-topbar">
      <button
        className="v2-btn v2-btn-ghost v2-btn-icon"
        onClick={onToggleSidebar}
        title={collapsed ? "Show sidebar" : "Hide sidebar"}
        data-testid="v2-topbar-toggle"
      >
        {collapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
      </button>

      {/* Breadcrumbs */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, color: "var(--v2-text-muted)", overflow: "hidden" }}>
        <Link to="/dashboard" style={{ color: "var(--v2-text-muted)" }}>Home</Link>
        {current && current.key !== "dashboard" && (
          <>
            <ChevronRight size={12} />
            <span style={{ color: "var(--v2-text)" }}>{current.label}</span>
          </>
        )}
      </div>

      {/* Command trigger */}
      <button
        type="button"
        className="v2-topbar-search v2-focus-ring"
        onClick={onOpenPalette}
        data-testid="v2-topbar-search"
        aria-label="Search"
      >
        <Search size={14} />
        <span style={{ flex: 1, textAlign: "left" }}>Search pages, orders, SKUs…</span>
        <span className="v2-kbd">⌘ K</span>
      </button>

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto" }}>
        <NotificationCenter />
        <ProfileMenu theme={theme} onToggleTheme={onToggleTheme} />
      </div>
    </header>
  );
}
